








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { CustomCols } from './MultipleImages.vue';
import ImagePopup from '@/components/Inspiration/ImagePopup.vue';

interface Image {
    url: string;
    title: string;
}

@Component({
    components: {
        ImagePopup
    }
})
export default class ImageMasonry extends Vue {
    @Prop({ default: () => [] }) private images!: Image[];
    @Prop({ default: true }) private showDescription!: boolean;
    @Prop({ default: true }) private isMasonry!: boolean;
    @Prop({ default: () => ({ default: 5, 900: 1 }) }) private cols!: CustomCols;

    constructor() {
        super();
    }
    
    private showImage(imageUrl: string) {
        this.$modal.show(
            ImagePopup,
            {
                imageUrl
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}

